import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';
import { getBranchName } from '../utils/warehousesUtils';

const WarehousesDataTable = ({
  data,
  branches,
  isLoading,
  onEdit,
  onDelete,
}) => {
  return (
    <GeneralTableBox>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Código</HeadTableCell>
            <HeadTableCell>Nombre</HeadTableCell>
            <HeadTableCell>Sucursal</HeadTableCell>
            <HeadTableCell>Dirección</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : data && data.length > 0 ? (
            data.map((warehouse) => (
              <TableRow key={warehouse.uuid}>
                <RowTableCell>{warehouse.code}</RowTableCell>
                <RowTableCell>{warehouse.name}</RowTableCell>
                <RowTableCell>{getBranchName(branches, warehouse.uuid_branch)}</RowTableCell>
                <RowTableCell>{warehouse.address || '-'}</RowTableCell>
                <RowTableCell>
                  <ActionIconButton variant="edit" onClick={() => onEdit(warehouse)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(warehouse)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton message="No se encontraron depósitos" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default WarehousesDataTable;
